import axios from "axios";
import { API_ROOT } from "./ApiConfig";

axios.defaults.withCredentials = true;
export default axios.create({
  baseURL: `${API_ROOT}/student-api/`
});
